<!-- Navbar Section -->
    <!-- Navbar -->
    <nav class="navbar navbar-expand-lg fixed-top custom-navbar h-12">
        <div class="container">
          <a class="navbar-brand" href="#">RCI Rentals</a>

          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
            aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>

          <div class="collapse navbar-collapse justify-content-end" id="navbarNav">
            <ul class="navbar-nav align-items-center">

              <li class="nav-item" *ngIf="currentRoute == '/'">
                <a class="nav-link nav-login" (click)="goToApply()">Apply Now</a>
              </li>
              <li class="nav-item">
                <ng-container *ngIf="user$ | async as user; else tenantPortal">
                  <!-- User is logged in -->
                  <a class="btn btn-dark nav-signup" (click)="goToDashboard()">Dashboard</a>
                </ng-container>

                <!-- User is not logged in -->
                <ng-template #tenantPortal>
                  <a class="btn btn-dark nav-signup" (click)="goToLogin()">Tenant Portal</a>
                </ng-template>
              </li>
              <li class="nav-item">
                <a class="nav-link nav-login" *ngIf="auth.user$ | async as user" (click)="logout()">Log Out</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
<main class="pt-5">
  <router-outlet></router-outlet>
</main>